import { BrowserRouter, useLocation } from 'react-router-dom'
import { ErrorBoundary } from '@sentry/react'
import { Flex, Theme } from '@radix-ui/themes'

import { LegacyVersionCallout } from '@/modules/app/components/LegacyVersionCallout'
import { FallbackErrorScreen } from '@/modules/app/components/FallbackErrorScreen'
import { SessionWarningModal } from '@/components/SessionWarningModal'
import { PaymentDueModal } from '@/modules/app/components/PaymentDueModal'
import { AppTopBar } from '@/modules/app/components/AppTopBar'
import { AppMenu } from '@/modules/app/components/AppMenu'
import { AppRoutes } from '@/modules/app/routes'
import { useAuth } from '@/hooks/useAuth'

const AppLayout = () => {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  // FIXME: This is an awful workaround to avoid showing the top bar and menu on fullscreen routes...
  const isFullScreenRoute = location.pathname.startsWith('/fullscreen')

  return (
    <ErrorBoundary fallback={<FallbackErrorScreen />}>
      <Flex direction="column" minHeight="100vh" width="100%">
        {!isFullScreenRoute && <AppTopBar />}

        {!isFullScreenRoute && isAuthenticated && <LegacyVersionCallout />}

        <Flex direction={{ initial: 'column', md: 'row' }} px="4" gap="4" flexGrow="1">
          {!isFullScreenRoute && isAuthenticated && <AppMenu />}
          <Flex overflow="auto" flexGrow="1" direction="column" minWidth="0">
            <AppRoutes />
          </Flex>
        </Flex>
      </Flex>

      {isAuthenticated && (
        <>
          <SessionWarningModal />
          <PaymentDueModal />
        </>
      )}
    </ErrorBoundary>
  )
}

export const App = () => (
  <Theme accentColor="red" grayColor="mauve" appearance="light" radius="large">
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  </Theme>
)
